module.exports = __webpack_public_path__ + "img/fish.9c03b9ab.svg";